export default "__VITE_ASSET__DK$xnjIw__"